/**
 * Utility for managing dynamic CSS styles in a CSP-compliant way
 * This adds CSS rules to the document head instead of using inline styles
 */

let styleElement: HTMLStyleElement | null = null;
const addedClasses = new Set<string>();

/**
 * Initialize the dynamic styles sheet
 */
function initializeDynamicStyles() {
  if (!styleElement) {
    styleElement = document.createElement('style');
    styleElement.id = 'dynamic-map-styles';
    document.head.appendChild(styleElement);
  }
}

/**
 * Add a CSS class with dynamic color to the stylesheet
 */
export function addDynamicColorClass(className: string, color: string): string {
  initializeDynamicStyles();
  
  if (!addedClasses.has(className) && styleElement) {
    const rule = `.${className} { background-color: ${color} !important; }`;
    styleElement.sheet?.insertRule(rule);
    addedClasses.add(className);
  }
  
  return className;
}

/**
 * Generate a safe CSS class name from a string
 */
export function generateSafeClassName(prefix: string, identifier: string): string {
  const safeIdentifier = identifier.replace(/[^a-zA-Z0-9]/g, '');
  return `${prefix}-${safeIdentifier}`;
}

/**
 * Clear all dynamic classes (useful for testing or cleanup)
 */
export function clearDynamicStyles() {
  if (styleElement && styleElement.sheet) {
    const rules = styleElement.sheet.cssRules;
    for (let i = rules.length - 1; i >= 0; i--) {
      styleElement.sheet.deleteRule(i);
    }
  }
  addedClasses.clear();
}